import { callService } from '@api/remote-call';
import { WishListViewModel } from '@api/v3';

export const DEFAULT_FAVORITE_LIST_NAME = 'Favorilerim';
export const ADDED_TO_LIST = 'Favori Listenize Eklendi';
export const REMOVED_FROM_LIST = 'Favorite Listenizden Kaldırıldı';

export const findDefaultList = (favoriteLists?: WishListViewModel[]) => {
  if (!Array.isArray(favoriteLists)) {
    return;
  }

  return favoriteLists?.find(
    (item) =>
      item?.default === true ||
      item?.name?.toLowerCase() === DEFAULT_FAVORITE_LIST_NAME.toLowerCase()
  );
};

export const recreateDefaultList = async (
  loginInfo,
  selectedItemAddedList,
  addFavoriteListItem,
  itemName,
  query,
  itemId,
  imageUrl,
  type,
  refetchFavoriteLists,
  refetchSelectedItemAddedList
) => {
  const data = await callService(
    {
      service: 'WishListsService',
      method: 'createWishList',
      version: 'v3',
    },
    {
      body: { name: 'Favorilerim' },
      authorization: loginInfo?.token || '',
    }
  );
  if (data) {
    try {
      const favoriteList = await callService(
        {
          service: 'WishListsService',
          method: 'getWishLists',
          version: 'v3',
        },
        {
          authorization: loginInfo?.token || '',
        }
      );
      const foundDefaultList = favoriteList?.find(
        (item) =>
          item.name?.toLowerCase() === DEFAULT_FAVORITE_LIST_NAME.toLowerCase()
      );
      const itemInDefaultList = selectedItemAddedList?.find(
        (item) => item.id === foundDefaultList?.id
      );
      if (foundDefaultList) {
        if (!itemInDefaultList) {
          addFavoriteListItem({
            wishListId: foundDefaultList?.id ?? '',
            body: {
              name: itemName,
              url: query?.slug?.toString(),
              itemId: itemId ?? 0,
              image: imageUrl,
              type: type,
            },
            authorization: loginInfo?.token || '',
          });
          refetchFavoriteLists();
          refetchSelectedItemAddedList();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
};
